import morphism, { StrictSchema } from 'morphism'

import ClientFlightPassengerToBeDeletedInterface from '../../interfaces/client/FlightPassengerToBeDeleted'
import ServerPassengerToBeDeletedFlightInterface from '../../interfaces/server/PassengerToBeDeletedFlight'
import PassengerToBeDeletedIncludingPassengerNamesInterface from '../../interfaces/server/PassengerToBeDeletedIncludingPassengerNames'

import clientFlightPassengerToDeleteSchema from './flightPassengerToDelete'

export const fullName = ({
  firstName,
  lastName,
}: PassengerToBeDeletedIncludingPassengerNamesInterface) =>
  firstName && lastName ? `${firstName} ${lastName}` : ''

export const infantName = ({
  infantFirstName,
  infantLastName,
}: PassengerToBeDeletedIncludingPassengerNamesInterface) =>
  infantFirstName && infantLastName
    ? `${infantFirstName} ${infantLastName}`
    : ''

export const outbound = ({
  outbound,
}: PassengerToBeDeletedIncludingPassengerNamesInterface) => {
  if (!outbound) return undefined

  return morphism<
    StrictSchema<
      ClientFlightPassengerToBeDeletedInterface,
      ServerPassengerToBeDeletedFlightInterface
    >
  >(clientFlightPassengerToDeleteSchema, outbound)
}

export const inbound = ({
  inbound,
}: PassengerToBeDeletedIncludingPassengerNamesInterface) => {
  if (!inbound) return undefined

  return morphism<
    StrictSchema<
      ClientFlightPassengerToBeDeletedInterface,
      ServerPassengerToBeDeletedFlightInterface
    >
  >(clientFlightPassengerToDeleteSchema, inbound)
}

export default {
  id: 'id',
  fullName,
  infantName,
  outbound,
  inbound,
}
